import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './CandidatureSuccess.css';

const Icons = {
  Check: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  ArrowLeft: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12"></line>
      <polyline points="12 19 5 12 12 5"></polyline>
    </svg>
  ),
};

const CandidatureSuccess = () => {
  const location = useLocation();
  const firstName = location.state?.firstName || 'Candidat';

  return (
    <div className="success-page">
      <div className="success-container">

        {/* App-style icon */}
        <div className="success-icon">
          <div className="icon-box">
            <Icons.Check />
          </div>
        </div>

        {/* Main message */}
        <h1>Bravo {firstName} !</h1>
        <p className="success-subtitle">
          Ta candidature a bien été envoyée.
        </p>

        {/* Motivational message */}
        <div className="success-message">
          <p>
            Tu viens de faire le premier pas vers ta nouvelle vie.
            <strong>La majorité des gens rêvent. Toi, tu agis.</strong>
          </p>
        </div>

        {/* Next steps */}
        <div className="success-steps">
          <h2>Et maintenant ?</h2>

          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <h3>Sous 48h</h3>
              <p>Un formateur analyse ton profil et vérifie ton éligibilité.</p>
            </div>

            <div className="step-card">
              <div className="step-number">2</div>
              <h3>Appel de sélection</h3>
              <p>Si ton profil correspond, on te contacte pour un appel de 15-20 min.</p>
            </div>

            <div className="step-card">
              <div className="step-number">3</div>
              <h3>Check tes emails</h3>
              <p>Pense à vérifier tes spams. On t'envoie une confirmation.</p>
            </div>
          </div>
        </div>

        {/* Quote */}
        <div className="success-quote">
          <p>"Dans 30 jours, tu auras soit des excuses, soit des résultats."</p>
          <span>— F12IA</span>
        </div>

        {/* Back to home */}
        <Link to="/" className="back-link">
          <Icons.ArrowLeft />
          Retour à l'accueil
        </Link>

      </div>
    </div>
  );
};

export default CandidatureSuccess;
